import { z } from 'zod'

export const GetChatMessageSchema = z.object({
  chat_id: z.number().nullish(),
  created_at: z.coerce.date(),
  id: z.number(),
  message: z.string(),
  read_at: z.string().nullish(),
  user_id: z.number(),
  user_id_no_read: z.number().nullish(),
})

export const GetChatSchema = z.object({
  id: z.number(),
})
